import React, { useEffect, useMemo, useState } from "react";

import { useTranslation } from "react-i18next";

import { useReduxSelector } from "@hooks/useReduxSelector";
import { ShapeTable } from "@routes/IconeSvg";

import Button from "@components/tailwindComponents/Button";
import BlackTooltip from "@components/tooltip/BlackTooltip";

import evaluationResultService from "@services/evaluation/evaluationResult.service";

export default function QuestionItem({
  showQuestionCollapse,
  assignedEmployee,
  evaluationType
}) {
  const { t: translator } = useTranslation("assesment.frequency");

  const questionList = useReduxSelector(
    ({ evaluation }) => evaluation.evaluationQuestion.list
  );

  const [fadeStatus, setFadeStatus] = useState(false);
  const toggleFadeStatus = () => {
    setFadeStatus((_fadeStatus) => !_fadeStatus);
  };
  const [questionsAnswers, setQuestionsAnswers] = useState({});

  useEffect(() => {
    const fetchAllAnswers = async () => {
      let newEmptyAnswers =
        (await evaluationResultService.getQuestionsAnswers({
          employeIds: assignedEmployee ? [assignedEmployee] : [],
          questionIds: questionList.map((question) => question._id),
          evaluationType
        })) || [];

      newEmptyAnswers = newEmptyAnswers.reduce(
        (acc, questionAnswers) => ({
          ...acc,
          [questionAnswers._id]: questionAnswers.answers
        }),
        {}
      );
      setQuestionsAnswers(newEmptyAnswers);
    };

    if (fadeStatus) {
      fetchAllAnswers();
    }
  }, [fadeStatus, questionList, assignedEmployee, evaluationType]);

  const mappedQuestionList = useMemo(() => {
    return questionList
      .map((question) => {
        const answers = questionsAnswers[`${assignedEmployee}_${question._id}`];
        return {
          ...question,
          answers
        };
      })
      .filter((question) => question.answers?.length > 0);
  }, [questionList, questionsAnswers, assignedEmployee]);

  return (
    <>
      <tr className="arh-border arh-border-x-0 arh-border-t-0 arh-border-solid arh-border-borderTable">
        <td className="arh-border-y-0 arh-border-l-0 arh-border-r arh-border-solid arh-border-borderTable arh-bg-greyColor arh-px-4  arh-py-4 arh-text-start arh-font-poppins arh-text-xs arh-font-semibold arh-text-darkColor">
          <div
            className="arh-flex arh-w-full arh-cursor-pointer arh-items-center arh-justify-between arh-py-[0.938rem] "
            onClick={toggleFadeStatus}
          >
            <div className="arh-max-w-parent-table-evaluation arh-flex arh-flex-1 arh-items-start">
              {/* <div className="arh-mr-[0.625rem] arh-h-[0.438rem] arh-w-[0.438rem] arh-rounded-full"></div> */}
              <BlackTooltip
                title={translator("Questions")}
                placement="top-start"
              >
                <span className="arh-max-w-name-table arh-mt-0.5 arh-line-clamp-2 arh-max-w-fit arh-font-poppins arh-text-xs arh-font-semibold arh-text-black">
                  {translator("Questions")}
                </span>
              </BlackTooltip>
            </div>
            <div
              className={`arh-transition arh-duration-200 ${fadeStatus ? "arh-rotate-180-main -arh-rotate-180 " : "arh-rotate-0"}`}
            >
              {ShapeTable()}
            </div>
          </div>
        </td>
        <td className="arh-px-4 arh-py-4 arh-text-center arh-font-poppins arh-text-xs arh-font-semibold arh-text-darkColor ">
          -
        </td>
        <td className="arh-px-4 arh-py-4 arh-text-center arh-font-poppins arh-text-xs arh-font-semibold arh-text-darkColor ">
          -
        </td>
        <td className="arh-px-4 arh-py-4 arh-text-center arh-font-poppins arh-text-xs arh-font-semibold arh-text-darkColor ">
          -
        </td>
        <td className="arh-px-4 arh-py-4 arh-text-center arh-font-poppins arh-text-xs arh-font-semibold arh-text-darkColor ">
          -
        </td>
        <td className="arh-px-4 arh-py-4 arh-text-center arh-font-poppins arh-text-xs arh-font-semibold arh-text-darkColor ">
          -
        </td>
      </tr>

      {fadeStatus &&
        mappedQuestionList.map((question) => {
          const answers = question.answers;

          return (
            <tr
              key={question._id}
              className="arh-border arh-border-x-0 arh-border-t-0 arh-border-solid arh-border-borderTable"
            >
              <td className="arh-border-y-0 arh-border-l-0 arh-border-r arh-border-solid arh-border-[#EAECF0] arh-bg-[#FDFDFD] arh-px-4 arh-py-[0.688rem] ">
                <BlackTooltip
                  title={question.question}
                  placement="top-start"
                >
                  <p className="arh-m-0 arh-line-clamp-2 arh-w-full arh-max-w-fit arh-p-0 arh-text-start arh-font-poppins arh-text-xs arh-font-semibold arh-text-darkColor">
                    {question.question}
                  </p>
                </BlackTooltip>
              </td>

              <td className="arh-px-16 arh-py-1">
                <div className="arh-flex arh-w-full arh-items-center arh-justify-center">
                  {answers?.length ? (
                    <Button
                      variant="green-outlined"
                      onClick={() => showQuestionCollapse(question, answers)}
                    >
                      {translator("Voir")}
                    </Button>
                  ) : (
                    <span className="arh-font-medium arh-text-darkGreyColor">
                      -
                    </span>
                  )}
                </div>
              </td>

              <td className="arh-px-4"></td>
              <td className="arh-px-4"></td>
              <td className="arh-px-4"></td>
              <td className="arh-px-4"></td>
            </tr>
          );
        })}
    </>
  );
}
